import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app/App";
import { GlobalErrorBoundary } from "./app/GlobalErrorBoundary";
import { AuthProvider } from "./auth/AuthContext";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/auth.css";
import "./styles/admin.css";
import "./styles/taxonomy.css";
import "./styles/dogs.css";
import "./styles/ownership.css";
import "./styles/ownership-directory.css";
import "./styles/pedigree.css";
import "./components/ui/ui.css";

const root = document.getElementById("root");
if (!root) throw new Error("Không tìm thấy root element.");

createRoot(root).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </GlobalErrorBoundary>
  </StrictMode>,
);
